import React from 'react'
import { Trans } from 'react-i18next'

import { SvgImage } from 'components/SvgImage'

import heartIcon from 'assets/images/sprite/heart-plus-outline-icon.svg'
import starIcon from 'assets/images/sprite/star-gold-bright.svg'

import { StyledTrustPilotBannerVariant1 as S } from './TrustPilotBannerVar1.styles'

export const TrustPilotBannerVariant1 = () => {
  return (
    <S.Container>
      <S.Block>
        <SvgImage svg={heartIcon} width={20} />
        <S.Text>
          <Trans i18nKey="onboarding.selectGenderKarma.trustpilot1.usersChoice" />
        </S.Text>
      </S.Block>

      <S.Separator />

      <S.Block>
        <SvgImage svg={starIcon} width={20} />
        <S.Text $nowrap>
          <Trans i18nKey="onboarding.selectGenderKarma.trustpilot1.rating" />
        </S.Text>
      </S.Block>
    </S.Container>
  )
}
